import React from 'react';

import {PB_ADMIN} from 'src/hooks/access-resource-constant';
import {useCurrentUser} from 'src/hooks/useCurrentUser';
import {VendorApprovalRule} from 'src/openapi/admin/models/VendorApprovalRule';

import {FlatButton} from '@pb/kit-component-button';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import Icon, {Icons} from '@pb/kit-component-icon';
import {Tooltip} from '@pb/kit-component-popups';
import {Body, Cell, Head, Row, Table} from '@pb/kit-component-table';

import {formatStatus} from '../../utils';


type Props = {
    rules: VendorApprovalRule[],
    deletingMap: Record<string, boolean>,
    onDelete: (ruleId: string) => void,
};

const numberW = 40;
const ruleNameW = 200;
const grantNameW = 200;
const grantDescriptionW = 260;
const grantStatusW = 120;
const grantIdW = 220;
const actionW = 70;

export const RulesTable: React.FC<Props> = ({rules, deletingMap, onDelete}) => {
    const {hasAccessToResource} = useCurrentUser();
    const canDeleteRule = hasAccessToResource(PB_ADMIN.DELETE_RULE);
    return (
        <Table>
            <Head>
                <Row>
                    <Cell width={numberW}>#</Cell>
                    <Cell width={ruleNameW}>Rule Name</Cell>
                    <Cell width={grantNameW}>Grant Name</Cell>
                    <Cell width={grantDescriptionW}>Grant Description</Cell>
                    <Cell width={grantStatusW}>Grant Status</Cell>
                    <Cell width={grantIdW}>Grant ID</Cell>
                    <Cell width={actionW} className="text-align_center"></Cell>
                </Row>
            </Head>
            <Body>
                {rules.map((rule, index) => {
                    const grantName = rule.entitlementName ?? '';
                    const grantDescription = rule.entitlementDescription ?? '';
                    const grantStatus = formatStatus(rule.entitlementStatus) ?? '';
                    const grantId = rule.entitlementId ?? '';

                    return (
                        <Row key={rule.ruleId}>
                            <Cell width={numberW}>{index + 1}</Cell>
                            <Cell width={ruleNameW}>
                                <EllipsisTextHint title={rule.ruleName}>
                                    {rule.ruleName}
                                </EllipsisTextHint>
                            </Cell>
                            <Cell width={grantNameW}>
                                <EllipsisTextHint title={grantName}>
                                    {grantName}
                                </EllipsisTextHint>
                            </Cell>
                            <Cell width={grantDescriptionW}>
                                <EllipsisTextHint title={grantDescription}>
                                    {grantDescription}
                                </EllipsisTextHint>
                            </Cell>
                            <Cell width={grantStatusW}>
                                <EllipsisTextHint title={grantStatus}>
                                    {grantStatus}
                                </EllipsisTextHint>
                            </Cell>
                            <Cell width={grantIdW}>
                                <EllipsisTextHint title={grantId}>
                                    {grantId}
                                </EllipsisTextHint>
                            </Cell>
                            <Cell width={actionW} className="text-align_center">
                                {canDeleteRule ? (
                                    <Tooltip
                                        anchor={({anchorRef, getAnchorProps}) => (
                                            <FlatButton
                                                ref={anchorRef}
                                                {...getAnchorProps()}
                                                aria-label={`Delete ${rule.ruleName}`}
                                                onClick={() => onDelete(rule.ruleId)}
                                                disabled={Boolean(deletingMap[rule.ruleId])}
                                                startIcon={<Icon type={Icons.TRASH}/>}
                                            />
                                        )}>
                                        Remove Rule
                                    </Tooltip>
                                ) : null}
                            </Cell>
                        </Row>
                    );
                })}
            </Body>
        </Table>
    );
};
